/**
 * IB / Carteira account lifecycle — mirrors MobileService
 * AccountsController.ResolveAccountLifecycle / Baas AccountLifecycleCatalog.
 */

export const INACTIVE_ACCOUNT_LIFECYCLES = new Set([
  "suspended",
  "blocked",
  "deactivated",
]);

/** Recompute from flags when API string is missing or contradicts Active/Closed. */
const resolveLifecycleFromFlags = (account) => {
  const closed =
    account.closedAccount === true
    || account.closed_account === true;
  if (closed) return "deactivated";

  const inactive =
    account.active === false
    || account.accountStatusId === 6
    || account.account_status_id === 6;
  if (inactive) {
    const support = String(
      account.supportStatus || account.support_status || "",
    ).trim().toUpperCase();
    if (support === "SUSPENDED") return "suspended";
    if (support === "DEACTIVATED") return "deactivated";
    return "blocked";
  }

  return "active";
};

export const resolveAccountLifecycle = (account) => {
  if (!account) return "active";

  const listed = String(
    account.lifecycle || account.account_lifecycle || account.accountLifecycle || "",
  ).trim().toLowerCase();

  const fromFlags = resolveLifecycleFromFlags(account);

  // Prefer the richer API string when it already marks the account inactive.
  if (INACTIVE_ACCOUNT_LIFECYCLES.has(listed)) return listed;

  // Stale /me may still say "active" while Active=false / Closed / StatusId=6.
  if (fromFlags !== "active") return fromFlags;

  if (listed) return listed;
  return "active";
};

export const isInactiveAccountLifecycle = (lifecycle) =>
  INACTIVE_ACCOUNT_LIFECYCLES.has(String(lifecycle || "").trim().toLowerCase());

export const isInactiveOperatingAccount = (account) =>
  isInactiveAccountLifecycle(resolveAccountLifecycle(account));
